module.exports = __webpack_public_path__ + "static/img/Slide-Serv-2.bcdbb8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Slide-Serv-2.png
// module id = zseI
// module chunks = 0